import React from 'react';
import { Field } from 'redux-form';
import { isString } from 'lodash';
import { compose, withHandlers, withPropsOnChange } from 'recompose';
import Input from '../Input';
import createLabel from '../createLabel';

import styles from './styles.css';
const cx = require('classnames');

const Range = compose(
  withHandlers({
    onChangeMin:
      ({ input, min, max }) =>
      (e) => {
        const value = e.target.value;
        if (value < min) return input.onChange({ ...input.value, min });
        if (value > max) return input.onChange({ ...input.value, min: max });
        return input.onChange({ ...input.value, min: value });
      },
    onChangeMax:
      ({ input, min, max }) =>
      (e) => {
        const value = e.target.value;
        if (value > max) return input.onChange({ ...input.value, max });
        if (value < max) return input.onChange({ ...input.value, max: min });
        return input.onChange({ ...input.value, max: value });
      },
  })
)(
  ({
    input: { onBlur, onFocus, value },
    meta,
    onChangeMin,
    onChangeMax,
    className,
    inline,
    width,
    label,
    min,
    max,
    ...rest
  }: any) => (
    <div className={cx(styles.wrapper)}>
      <div className={styles.root}>
        <Input
          inline
          {...rest}
          meta={{}}
          label={label[0]}
          style={{ width }}
          input={{
            onChange: onChangeMin,
            value: (value && value.min) || min,
          }}
          className={styles.input}
        />
        <Input
          inline
          {...rest}
          meta={{}}
          label={label[1]}
          style={{ width }}
          input={{
            onChange: onChangeMax,
            value: (value && value.max) || max,
          }}
          className={styles.input}
        />
      </div>
      {meta.touched && meta.touched && (
        <div className={styles.error}>{meta.touched}</div>
      )}
    </div>
  )
);

export const FormRange: any = ({ component, type, isNative, ...rest }) => (
  <Field {...rest} component={Range} type="number" />
);

export default Range;
